/**
 * Normalizes a phone number by removing all non-numeric characters except the leading plus sign.
 * @param phone The phone number string to normalize.
 * @returns Normalized phone number in E.164 format (if valid).
 */
export const normalizePhoneNumber = (phone: string): string => {
    // Remove all non-digit characters except the leading '+'
    const cleaned = phone.trim();
    const hasPlus = cleaned.startsWith('+');
    const digits = cleaned.replace(/\D/g, '');

    return hasPlus ? `+${digits}` : digits;
};

/**
 * Validates if the phone number is in a valid E.164 format.
 * Expects the number to have already been normalized.
 * @param phone The normalized phone number.
 * @returns boolean
 */
export const isValidPhoneNumber = (phone: string): boolean => {
    // E.164 format: + followed by 7 to 15 digits
    const e164Regex = /^\+[1-9]\d{7,14}$/;
    return e164Regex.test(phone);
};
